export const shouldForceOtroDocumentoProbatorio = (countryCode, isIntracomunitario, isCompany) => {
    // Para cliente español nunca forzamos Otro documento probatorio
    const isSpain = countryCode.toLowerCase() === 'es';
    if(isSpain) return false;

    // Si es empresa de país intracomunitario, no forzamos Otro documento probatorio
    if(isIntracomunitario && isCompany) return false;

    // En cualquier otro caso, el tipo de documento enviado a nemon siempre será Otro documento probatorio
    return true;
}